<template>
  <div
    class="event-info"
    data-ui="event-info"
  >
    <h1
      :data-session-id="sessionData.sessionId"
      class="event-info__heading"
      data-ui="event-details-title"
    >
      {{ pageTitle }}
    </h1>
    <div class="event-info__date-time">
      <DateTimeComponent
        :session-end="sessionData.end"
        :session-start="sessionData.start"
        :timezone="
          !!sessionData.meetingLocation
            ? sessionData.meetingLocation.timezone
            : sessionData.location.timezone
        "
        type="current-session"
      />
      <CdrLink
        v-if="otherSessions"
        :href="moreDatesUrl"
        class="event-info__more-dates event-info__more-dates--date-bar"
        data-ui="more-dates-link"
        @click="() => handleClick('View more dates')"
      >
        More dates
      </CdrLink>
    </div>
    <div class="event-info__location">
      <div
        v-if="locationLinkProps"
        class="event-info__location-link"
        data-ui="event-info-location-name"
      >
        <CdrLink
          v-bind="locationConfig"
          @click="() => handleClick('session location')"
        >
          <IconLocationPinFill class="event-info__location-icon" />
          {{ locationLinkProps.text }}
        </CdrLink>
      </div>
      <div
        v-if="meetAtProps"
        class="event-info__meet-at"
        data-ui="meet-at"
      >
        <CdrText
          class="event-info__meet-at-ligature"
          tag="span"
        >
          Meet at&nbsp;
        </CdrText>
        <CdrLink
          v-if="meetAtProps.href"
          v-bind="meetAtProps"
          class="event-info__location-link event-info__location-link--meet-at"
          target="_blank"
          @click="() => handleClick('meet at location')"
        >
          <template v-if="meetAtProps.text">
            {{ meetAtProps.text }}
          </template>
          <IconExternalLink
            v-else
            data-ui="event-details-meet-at-location"
          />
        </CdrLink>
        <CdrText
          v-else
          class="event-info__location-link event-info__location-link--non-link"
        >
          {{ meetAtProps.text }}
        </CdrText>
      </div>
    </div>
  </div>
  <!--
    other modals on page
      - fitness-level-modal
      - skill-level-modal
      - gear-list-modal
  -->
</template>

<script>
import { CdrLink, CdrText, IconExternalLink, IconLocationPinFill } from '@rei/cedar';
import metrics from '../mixins/metrics';
import DateTimeComponent from './DateTimeComponent.vue';

export default {
  name: 'SessionHeadingInfoComponent',
  components: {
    CdrLink,
    CdrText,
    IconExternalLink,
    IconLocationPinFill,
    DateTimeComponent,
  },
  mixins: [metrics],
  props: {
    deviceSize: {
      type: String,
      required: true,
    },
    locationLinkProps: {
      type: [Boolean, Object],
      required: false,
      default: false,
    },
    locationIsStore: {
      type: Boolean,
      required: true,
    },
    meetAtProps: {
      type: [Boolean, Object],
      required: false,
      default: false,
    },
    moreDatesUrl: {
      type: String,
      required: true,
    },
    otherSessions: {
      type: Boolean,
      required: true,
    },
    pageTitle: {
      type: String,
      required: true,
    },
    sessionData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    listModifier() {
      return `${this.deviceSize === 'mobile' ? '' : 'inline unordered'}`;
    },
    locationConfig() {
      if (!this.locationLinkProps) return {};
      const { href, type } = this.locationLinkProps;
      const config = {
        modifier: 'standalone',
        href,
      };
      if (type === 'url') config.target = '_blank';
      return config;
    },
  },
  methods: {
    handleClick(location) {
      const linkName = `{{ pageName }}_heading info_${location}`;
      this.metricsClick({ linkName });
    },
  },
};
</script>
